import React from 'react';
import { ReactComponent as IconSvg } from '@/images/icons/account_expired.svg';
const AccountExpired = () => React.createElement(IconSvg, null);
export default AccountExpired;
